
	/* Rotary dial object.
	10/6/2020 Converted to TS
		//// Mousewheel not implemented
		//// Hand cursor not implemented
	Events dispatched:
	DIAL_PRESSED
	DIAL_RELEASED
	DIAL_CHANGED
        //window.addEventListener("DIAL_CHANGED", this.onDialChange.bind(this));

    s = snug
    t = tight
    c = counterclockwise
    w = clockwise


	 10/3/2008: Removed move event handler and added doOnEnterFrame handler so knob keeps turning when mouse pulls out of it.
	 9/11/08: Added move event handler, which eliminates the need for the parent to call update()
	 8/30/08: Fixed hardLimits = false case.
	 11/19/07: Converted to AS3, renamed Dial3AS3  RB.  stuck MC's are not supported.
	 8/31/06: Fixed hardLimits option
	

	   	dial_mc.valMin = -5; // If hardLimits = true, sets the lower value limit.  Default = 0.
	   	dial_mc.valMinSnug = -4; // Turns on snugMin indicator
	   	dial_mc.valMaxSnug = 4; // Turns on snugMax indicator
		dial_mc.valMax = 5; // If hardLimits = true, sets the upper value limit. Default = 1.
		dial_mc.hardLimits = true; // Stops the knob from turning outside valMin and valMax. Default = false.
		dial_mc.dialScale = 2; // Sets value units per turn.  Default = 1.
		dial_mc.angleAtZeroTurns = 45; // Sets knob angle corresponding to zero turns.  Default is zero.
		dial_mc.valAtZeroTurns = 3;  //   Sets the value that corresponds to zero turns. Default is zero.
		dial_mc.val = -2;      // Spins the dial to that value. Default is zero.
		dial_mc.snap = true; // Turns on snapping.  Default is false.
		dial_mc.snapInterval = 0.2; // Sets snap interval. Default is 0.1
		dial_mc.useMouseWheel = true; // Enables mouse wheel.  Default is true.
		dial_mc.wheelSensitivity = 1; // How many turns of dial corresponds to one full physical rotation of the mouse wheel.
		dial_mc.locked = false; // Set to true if dial should behave as if it is locked still (even if not at limits).
		dial_mc.enableDrag = true;
		dial_mc.hasTightnessIndicators = true; // Must be symbols snugMax, snugMin, stuckMax, stuckMin
		dial_mc.tightness    Read only.
        	"TC" // Tight counterclockwise
        	"SC" // Snug counterclockwise
        	"L" //"Loose"
        	"SW" // Snug clockwise
        	"TW" // Tight clockwise


		

		To use the dial:
			Read dial_mc.val, dial_mc.dialAngleAbs, dial_mc._dialTurnsAbs
			Use val = v to spin the dial.
		
		On value change, dispatches a DIAL_CHANGED event on window with detail object properties:
			name			Whatever you had set the instance name property to
			val				Current value




	*/
import AnimateProxyBase from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-proxy-base";
import AnimateButtonProxy from "SATPROF_LIBRARY/DropinSupervisor/animate-proxys/animate-button-proxy";
import TimingInfo from "SATPROF_LIBRARY/DropinSupervisor/timing-info";
import AnimateRenderSpace from "SATPROF_LIBRARY/DropinSupervisor/render-spaces/animate-render-space";
import UtilSP from "SATPROF_UTILS/UtilSP"; 
import { StringKeyframeTrack, AudioAnalyser } from "three";

export default class Dial extends AnimateProxyBase{
 
	private mouseAtStartDrag:createjs.Point; // In parent's space
	private symbolAtStartDrag:createjs.Point; // In parent's space
	private thetaRatStartDrag:number; 
	private mouseNow:createjs.Point;
	private ready:boolean = false;

	// Settable properties:
	private _valMin:number = 0; // Min allowable value; (Settable)
	private _valMax:number = 1; // Max allowable value returned; (Settable)
	private _valMinSnug:number = 0.1; // Max allowable value returned; (Settable)
	private _valMaxSnug:number = 0.9; // Max allowable value returned; (Settable)
	private _enableDrag:boolean = true; // Prevents user from dragging it
	private _hardLimits:boolean = false; // Allow user to turn the dial past _valMin and _valMax. 
	private _DialScale:number = 1; // value units per turn (settable)
	private _snap:boolean = false; // 
	private _snapInterval:number = .1; //
	private _wheelSensitivity:number = 1;
	private _useMouseWheel:boolean = true;
	private _locked:boolean = false;
	public name:string = "";
	
	// Result properties:
	private _val:number = 0;  // Value returned
	private _dialAngleAbs:number;
	private _dialTurnsAbs:number;
	private stuckAtMax:boolean = false;
	private stuckAtMin:boolean = false;
	private _dialPressed:boolean;
	private _base:number = 2;
	

	// Internal properties
	private DialAngleAbsLast:number;
	private dialTurnsDelta:number;
	private offset:number = 0; // Not used?
	private _valAtZeroTurns:number = 0;
	private DialAngleAtZeroTurns:number = 0;
	private dialAngleAtStartDrag:number = 0;

	private _alwaysShowTightness:boolean = false;
	private _tightness:string = "L";
	private _hasTightnessIndicators:boolean = false;


    onFrameZero(){
        //console.log("In Dial.onFrameZero()");
        super.onFrameZero();
        const animate_rs:AnimateRenderSpace = this.extraData.animateSpace;
        //this.stageSymbol.outline_mc.rotation = 20;
        this.initialize();

    }
	public initialize(){

		//console.log("FYI, in Dial_p.ts, finished initializing.");
       	this.ready = true;
		this.stageSymbol.addEventListener("mousedown", this.startDrag.bind(this));
		this.stageSymbol.addEventListener("pressmove", this.dragHandler.bind(this));
		this.stageSymbol.addEventListener("pressup", this.stopDrag.bind(this));
		this.stageSymbol.cursor = "pointer"; // Gives it a hand cursor
		this.reset();
    }  
    onRequestAnimFrame(timingInfo : TimingInfo) {
        // Do every frame

	}  
	startDrag(evt){
		//console.log("In startDrag");
		//console.log("  this._dialAngleAbs = "+this._dialAngleAbs)
		this._dialPressed = true;

		this.mouseAtStartDrag = this.stageSymbol.parent.globalToLocal(evt.stageX, evt.stageY);
		this.symbolAtStartDrag = new createjs.Point(this.stageSymbol.x,this.stageSymbol.y); 
		//console.log("  symbolAtStartDrag"+this.symbolAtStartDrag)
		this.mouseNow = new createjs.Point(this.mouseAtStartDrag.x, this.mouseAtStartDrag.y);

		let dx:number =  this.mouseAtStartDrag.x - this.symbolAtStartDrag.x;
		let dy:number =  this.mouseAtStartDrag.y - this.symbolAtStartDrag.y;
		this.thetaRatStartDrag = Math.atan2(dy, dx);
		this.dialAngleAtStartDrag = this._dialAngleAbs;
		this.updateTightness();
		const event = new CustomEvent('DIAL_PRESSED', { detail:{name:this.name, val:this.val} });
		window.dispatchEvent(event);
	}
	dragHandler(evt){
		//console.log("In dragHandler");
		this.mouseNow = this.stageSymbol.parent.globalToLocal(evt.stageX, evt.stageY);
		this.update();

	}
	stopDrag(evt){
		////dispatchEvent(new CustomEvent("DIAL_RELEASED",false,false,arg1text,arg2));
		//console.log("In stopDrag")
		this._dialPressed = false;
		this.update();
		const event = new CustomEvent('DIAL_RELEASED', { detail:{name:this.name, val:this.val} });
		window.dispatchEvent(event);
	}
	knobChangedHandler(e:Event) {
		//console.log("DIAL_CHANGED event.  Type = "+e.type+", Name = "+e.arg[0]+", new val = "+e.arg[1]);//access arguments array
		//this._gain = this.stageSymbol.meterFullsize.knob.val;
	}
	/* ////
	public mouseWheelHandler(event:MouseEvent) {
		let valLast = this.val;
		if (this._useMouseWheel && !this._locked){
			let del = event.delta;
			let wheelStepDeg = del * this._wheelSensitivity * 7;  // Assume 7 deg per step of the mouse with sensitivity = 1;
			let valStep = this.dialScale * wheelStepDeg/360;
			this.valReq = this._val + valStep;
			this.processvalReq();
			//console.log("wheelStepDeg = "+wheelStepDeg+", valStep = "+valStep+", val = "+val);
			if (valLast != this.val){
				//console.log("Wheel: valLast = "+valLast+", val = "+val);
				////let arg1text = this.name; //"Hi there";
				////let arg2 = val;
				////dispatchEvent(new CustomEvent("DIAL_CHANGED",false,false,arg1text,arg2));
			}
		}
	
	}
	*/
	public reset(){
		this._dialTurnsAbs = 0;
		this._val = this._valAtZeroTurns;
		this._dialAngleAbs = this.DialAngleAtZeroTurns;
		this.stageSymbol.rotation = this._dialAngleAbs;
		///this.stuckGraphicMin_mc.visible = false;
		///this.stuckGraphicMax_mc.visible = false;

	}
	private setValAtZeroTurns(v){
		this._valAtZeroTurns = v;
		this.reset();
	}
	private setKnobAngle(a){
		this.DialAngleAtZeroTurns = a;
		this.reset();
	}
	
	public update(){
		//console.log("In Dial update...this._val = "+this._val+", this._enableDrag = "+this._enableDrag);

		let dx:number;
		let dy:number;

		dx =  this.mouseNow.x - this.symbolAtStartDrag.x;
		dy =  this.mouseNow.y - this.symbolAtStartDrag.y;
		let thetaR = Math.atan2(dy, dx);

		let deltaMouseR = thetaR - this.thetaRatStartDrag;
		let deltaMouseD = UtilSP.degrees(deltaMouseR);
		let DialAngleAbsReq = this.dialAngleAtStartDrag + deltaMouseD;
		//console.log("dx = "+dx+", dy = "+dy+", DialAngleAbsReq = "+DialAngleAbsReq+" "+this._dialPressed);
		//console.log("this.dialAngleAtStartDrag = "+this.dialAngleAtStartDrag);
		//console.log("deltaMouseD = "+deltaMouseD);

		let valLast = this._val;
		if (this._dialPressed == true && this._enableDrag == true && this._locked == false) {
			
			// Don't allow knob to past the _valMin and _valMax limits.
			this.DialAngleAbsLast = this._dialAngleAbs % 360; // Save where it was before, modulo 360
			DialAngleAbsReq %= 360; // Also force modulo 360.   // DialAngleAbsReq - Math.floor( DialAngleAbsReq / 360 ) * 360;
			let dialTurnsDeltaReq = this.dialdelta( this.DialAngleAbsLast, DialAngleAbsReq); // Unwrap and convert to delta fraction of a turn
			let deltaVal; // This will be the amount of final value change.
			let valReq:number = this._val + this._DialScale * dialTurnsDeltaReq; // The amount requested by the mouse motion.
			//console.log("deltaMouseD = "+deltaMouseD+", valReq = "+valReq+ " "+this._val +" "+this._DialScale+" "+dialTurnsDeltaReq);
			//console.log("this._dialAngleAbs = "+this._dialAngleAbs);
			//console.log("this.DialAngleAbsLast = "+this.DialAngleAbsLast);
			//console.log("DialAngleAbsReq = "+DialAngleAbsReq);
			//console.log("dialTurnsDeltaReq = "+dialTurnsDeltaReq);

			this.processvalReq(valReq);
			if (valLast != this.val){
				//console.log("valLast = "+valLast+", val = "+val+", _DialScale = "+_DialScale);
				//dispatchEvent(new CustomEvent("changed")); 
				////let arg1text = this.name; //"Hi there";
				////let arg2 = val;
				////dispatchEvent(new CustomEvent("DIAL_CHANGED",false,false,arg1text,arg2));
				//console.log("dispatching DIAL_CHANGED");
				const event = new CustomEvent('DIAL_CHANGED', { detail:{name:this.name, val:this.val} });
				window.dispatchEvent(event);

			}
		}
		this.updateTightness();
	}
	private processvalReq(valReq){
		let deltaVal;
		//console.log("In processvalReq, valReq = "+valReq);
		if (this._hardLimits) {
				
			if ( valReq < this._valMin ){
				// Reached lower limit
				deltaVal = this._valMin - this._val;
				this.val = this._valMin; // Use setter
				this.stuckAtMin = true;
			} else if ( valReq > this._valMax ) {
				// Reached upper limit
				deltaVal = this._valMax - this._val;
				this.val = this._valMax; // Use setter
				this.stuckAtMax = true;
			} else {
				// We have stayed within limits
				deltaVal = valReq - this._val;
				this.val = valReq; // Use setter
				this.stuckAtMin = false;
				this.stuckAtMax = false;
				///this.stuckGraphicMin_mc.visible = false;
				///this.stuckGraphicMax_mc.visible = false;
				//console.log("Hard limits on. deltaVal = "+deltaVal+", _val = "+this._val+", _valMin = "+this._valMin+", stuckAtMin = "+this.stuckAtMin+", stuckAtMax = "+this.stuckAtMax);
			}
			this.val = this._val; // Call th user setter function.  (Was setVal()); // Move the knob to follow where it ended.
		} else {
			deltaVal = valReq - this._val;
			this.val = valReq; // Use setter
			this.stuckAtMin = false;
			this.stuckAtMax = false;
			//console.log("Hard limits off. deltaVal = "+deltaVal+", _val = "+this._val);
			//this.val = this._val; // Call th user setter function.  (Was setVal()); // Move the knob to follow where it ended.
		}
	}
	private dialdelta( oldAngleDeg:number, newAngleDeg:number){
		// Unwraps dial and returns change in fraction of a turn.
		let deltaturns:number;
		// Force them to be positive modulo 360.
		let oldDeg = UtilSP.mod360(oldAngleDeg);
		let newDeg = UtilSP.mod360(newAngleDeg);
		
		if (newDeg == oldDeg){
			deltaturns = 0;
		} else if ( (newDeg > oldDeg) && (newDeg - oldDeg < 90) ){
			deltaturns = (newDeg-oldDeg)/360; // Normal positive step
		} else if ( (newDeg < oldDeg) && (oldDeg - newDeg < 90) ){
			deltaturns = (newDeg-oldDeg)/360; // Normal negative step
		} else if ( (newDeg +360 > oldDeg) && (newDeg+360 - oldDeg < 90) ){
			deltaturns = (newDeg+360-oldDeg)/360; // Positive step across the trip point
		} else if ( (newDeg < oldDeg+360) && (oldDeg+360 - newDeg < 90) ){
			deltaturns = (newDeg-(oldDeg+360))/360; // Normal negative step		
		} else {
			deltaturns = 0; // Ignore - jumped more than 90 deg
		}
		//console.log(oldDeg);
		//console.log("oldDeg = "+Util.formatFloat(oldDeg,7,2)+", newDeg = "+Util.formatFloat(newDeg,7,2)+", deltaturns = "+Util.formatFloat(deltaturns,7,2)); 
		return deltaturns;
	}
	private updateTightness(){
		let tightTol:number = 0.005 * (this._valMax-this._valMin);
		if (this._val <= (this._valMin+tightTol)){
			this._tightness = "TC";
		} else if (this._val > this._valMin && this._val <= this._valMinSnug){
			this._tightness = "SC";
		} else if (this._val > this._valMinSnug && this._val < this._valMaxSnug){	
			this._tightness = "L";	
		} else if (this._val >= this._valMaxSnug && this._val < (this._valMax-tightTol)){	
			this._tightness = "SW";	
		} else {
			this._tightness = "TW";	
		}
		//console.log("this._tightness = "+this._tightness+", this._dialPressed = "+this._dialPressed);

		if (this._hasTightnessIndicators){
			this.stageSymbol.stuckMin.visible = (this._tightness == "TC" && this._dialPressed);
			this.stageSymbol.snugMin.visible = (this._tightness == "SC" && this._dialPressed);
			this.stageSymbol.snugMax.visible = (this._tightness == "SW" && this._dialPressed);
			this.stageSymbol.stuckMax.visible = (this._tightness == "TW" && this._dialPressed);
		}
	}
	//-----------------------------------------------------------------------------
	// Setters and getters
	public set angleAtZeroTurns(a){
		this.DialAngleAtZeroTurns = a;
		this.reset();
	}
	public get angleAtZeroTurns():number{
		return this.DialAngleAtZeroTurns;
	}
	public set valAtZeroTurns(v){
		this._valAtZeroTurns = v;
		this.reset();
	}
	public get valAtZeroTurns():number{
		return this._valAtZeroTurns;
	}
	public get dialAngleAbs():number{
		return this._dialAngleAbs;
	}
	public get dialTurnsAbs():number{
		return this._dialTurnsAbs;
	}
	public get dialPressed():boolean{
		return this._dialPressed;
	}
	public get DialPressed():boolean{
		return this._dialPressed;
	}

	public set val(v){
		//console.log("In set val, spin the dial to ="+v);
		// Spin the dial _val = v
		// These are the key formulas:
		// _val = _DialScale * _dialTurnsAbs + valAtZeroTurns;
		// _dialAngleAbs = (_dialTurnsAbs % 1)*360 + DialAngleAtZeroTurns;
		// Therefore:
		if (this._snap){
			this._val = this._snapInterval * Math.round(v / this._snapInterval);
		} else {
			this._val = v;
		}
		this._dialTurnsAbs = (this._val - this._valAtZeroTurns)/this._DialScale;
		this._dialAngleAbs = (this._dialTurnsAbs % 1)*360 + this.DialAngleAtZeroTurns;
		this.stageSymbol.rotation = this._dialAngleAbs;
		//console.log("rot = "+this.rotation );
	}
	public get val():number{
		return this._val;
	}
	public set expval(vReq){
		if (vReq <= 0){
			console.log("ERROR in Dial.ts: attempt to set dial to negative value "+vReq+" in exponential mode. Ignored");
			return;
		}
		let v:number;
		v = Math.log(vReq)/Math.log(this._base);
		this.val = v; // Use setter
	}
	public get expval():number{
		return Math.pow( this._base, this._val);
	}
	public set expBase(v:number){
		this._base = v;
	}
	public get expBase():number{
		return this._base;
	}
	public setValNoSpin(v){
		// Sets the value to v, but does not turn the dial.
		if (this._snap){
			this._val = this._snapInterval * Math.round(v / this._snapInterval);
		} else {
			this._val = v;
		}
		//_dialTurnsAbs = (_val - _valAtZeroTurns)/_DialScale;
		// Shift _valAtZeroTurns so the abs turns is the same
		this._valAtZeroTurns = this._val - (this._dialTurnsAbs * this._DialScale);
		
		//_dialAngleAbs = (_dialTurnsAbs % 1)*360 + DialAngleAtZeroTurns;
		//this.rotation = _dialAngleAbs;
		//console.log("rot = "+this.rotation );

	}
	public setValDialScaleNoSpin(valNew, dialscaleNew){
		if (this._snap){
			this._val = this._snapInterval * Math.round(valNew / this._snapInterval);
		} else {
			this._val = valNew;
		}
		this._DialScale = dialscaleNew;
		this._valAtZeroTurns = this._val - (this._dialTurnsAbs * this._DialScale);
	}
	public setValExpBase(expvalReq:number, base:number){
		if (expvalReq <= 0){
			console.log("ERROR in Dial.ts: attempt to set dial to negative value in exponential mode. Ignored");
			return;
		}
		this._DialScale = 1;
		this._base = base;
		let v = Math.log(expvalReq)/Math.log(this._base);
		if (this._snap){
			this._val = this._snapInterval * Math.round(v / this._snapInterval);
		} else {
			this._val = v;
		}
		this._valAtZeroTurns = this._val - (this._dialTurnsAbs * this._DialScale);
	}

	public set valMin(v){
		this._valMin = v;
		///reset();
		//console.log("Just set _valMin = "+_valMin);
	}
	public get valMin():number{
		return this._valMin;
	}
	public set valMax(v){
		this._valMax = v;
		///reset();
	}
	public get valMax():number{
		return this._valMax;
	}

	public set valMinSnug(v){
		this._valMinSnug = v;
		///reset();
		//console.log("Just set _valMin = "+_valMin);
	}
	public get valMinSnug():number{
		return this._valMinSnug;
	}
	public set valMaxSnug(v){
		this._valMaxSnug = v;
		///reset();
	}
	public get valMaxSnug():number{
		return this._valMaxSnug;
	}	
	public set enableDrag(v){
		this._enableDrag = v;
		if (v){
			this.stageSymbol.cursor = "pointer"; // Gives it a hand cursor
		} else {
			this.stageSymbol.cursor = "";
		}
	}
	public get enableDrag():boolean{
		return this._enableDrag;
	}
	public set hardLimits(v){
		this._hardLimits = v;
		this.reset();
	}
	public get hardLimits():boolean{
		return this._hardLimits;
	}
	public set dialScale(v){
		this._DialScale = v;
		this.reset();
	}
	public get dialScale():number{
		return this._DialScale;
	}
	public set snap(v){ this._snap = v; };
	public get snap(){ return this._snap; };

	public set snapInterval(v){ this._snapInterval = v; };
	public get snapInterval(){ return this._snapInterval; };
	
	public set wheelSensitivity(v){ this._wheelSensitivity = v; };
	public get wheelSensitivity(){ return this._wheelSensitivity; };
	
	public set useMouseWheel(v){ this._useMouseWheel = v; };
	public get useMouseWheel(){ return this._useMouseWheel; };
	
	public set locked(v){ this._locked = v; };
	public get locked(){ return this._locked; };
	
	public get status(){
		let str = "";
		str += "val = "+this.val+"; ";
		str += "valMin = "+this.valMin+"; ";
		str += "valMax = "+this.valMax+"; ";
		str += "dialScale = "+this.dialScale+"; ";
		str += "hardLimits = "+this.hardLimits+"; ";
		str += "enableDrag = "+this.enableDrag+"; ";
		str += "expBase = "+this.expBase+"; ";
		str += "expval = "+this.expval+"; ";
		str += "dialPressed = "+this.dialPressed+"; ";
		str += "dialTurnsAbs = "+this.dialTurnsAbs+"; ";
		str += "valAtZeroTurns = "+this.valAtZeroTurns+"; ";
		str += "angleAtZeroTurns = "+this.angleAtZeroTurns+"; ";
		return str;
	}	
	public set alwaysShowTightness(val:boolean){
		this._alwaysShowTightness = val;
	}
	public get alwaysShowTightness(){
		return this._alwaysShowTightness;
	}	
	public set tightness(val:string){
		console.log("ERROR in dial_p.ts  trying to set tightness = "+val +" Tightness is read only." );
	
	}
	public get tightness():string{
		return this._tightness;
	}
	public set hasTightnessIndicators(val:boolean){
	 	this._hasTightnessIndicators = val;
		if (this._hasTightnessIndicators){
			this.stageSymbol.stuckMax.visible = false;
			this.stageSymbol.stuckMin.visible = false;
			this.stageSymbol.snugMax.visible = false;
			this.stageSymbol.snugMin.visible = false;
		}
	}
	public get hasTightnessIndicators(){
		return this._hasTightnessIndicators;
	}
	public quickInit2(v:number, vMin:number, vMinSnug:number, vMaxSnug:number, vMax:number, scale:number, 
			angleZeroTurns:number, valAtZeroTurns:number, hasTightIndicators:boolean){
		this.val = v;
		this.valMin = vMin;
		this.valMinSnug = vMinSnug;
		this.valMaxSnug = vMaxSnug;
		this.valMax = vMax;
		this.dialScale = scale;
		this.angleAtZeroTurns = angleZeroTurns;
		this.valAtZeroTurns = valAtZeroTurns;
		this.hasTightnessIndicators = hasTightIndicators;
		this.hardLimits = true;
	}
	public get quickStat(){
		return this._tightness;
    }	
}

